var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CTableWrapper',{attrs:{"items":_vm.languages,"is-loading":_vm.isLoading,"small":"","fixed":"","border":"","sorter":"","sorter-value":{ column: 'name', asc: true },"column-filter":"","fields":_vm.fields,"type":"Language","icon":"cil-tags","caption":"Languages"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }